// Unknown routes are administrative tools by default. New pages must opt in
// explicitly before Support can see them or mount their data-fetching children.
export function permissionForAdminPath(path) {
  if (path === "/admin/users" || path.startsWith("/admin/user/")) return "users.read";
  if (path === "/admin/roles") return "admin.manageRoles";
  if (path === "/admin/logs") return "users.readActivity";
  if (path.startsWith("/admin/completion/")) return "completions.readContent";
  if (path.startsWith("/admin/invocation/")) return "invocations.readContent";
  if (path.startsWith("/admin/document/")) return "documents.readContent";
  if (path.startsWith("/admin/card-set/")) return "cardsets.readContent";
  if (path.startsWith("/admin/canvas/")) return "projects.readContent";
  if (path === "/admin/chats") return "chats.readContent";
  if (path === "/admin") return "invocations.readContent";
  return "admin.tools";
}

export function filterAdminNavigation(sections, can) {
  return sections.map(section => ({
    ...section,
    items: section.items.filter(item => can(item.permission || (item.path ? permissionForAdminPath(item.path) : "admin.tools"))),
  })).filter(section => section.items.length > 0);
}
